export enum SwitchContext {
  Switched = 'switched',
  CannotSwitch = 'cannotSwitch',
}
